import * as React from 'react';
import { AxiosResponse, CancelToken } from 'axios';
import { useAuth } from '@domain/auth/auth.hook';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { GridColumns } from '@material-ui/data-grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { PlayerSessionDataProps } from '@screens/players/player.details.tabs/sessions/player.session.data.props';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';

const columns: GridColumns = [
  { field: 'roundId', headerName: 'Round Id', width: 130 },
  { field: 'datee', headerName: 'Date', width: 180, ...formatColWithDate },
  { field: 'action', headerName: 'Action', width: 200 },
  { field: 'chips', headerName: 'Chips', width: 180 },
  { field: 'remoteC', headerName: 'Remote C', width: 180 },
];

const columnsWithGreens: GridColumns = [...columns];
columnsWithGreens.splice(3, 0, { field: 'greens', headerName: 'Greens', width: 130 });
columnsWithGreens.splice(5, 0, { field: 'remoteG', headerName: 'Remote G', width: 180 });

interface SessionsDetails {
  roundId: number;
}

let index = 0;
function createData(sessionsDetails: SessionsDetails) {
  index += 1;
  return { id: index, ...sessionsDetails };
}

const PlayerSessionsDetails = (sessionDataProps: PlayerSessionDataProps) => {
  const game = useGame();
  const { authorizedServices } = useAuth();

  async function runSearch(sessionData: PlayerSessionDataProps, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<SessionsDetails[]>(`/admin/sessions/details/${sessionData.sessionId}?gameSessionId=${sessionData.gameSessionId}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<SessionsDetails[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(sessionDataProps, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];

  return (
    <TabTableContainer>
      <MainDataGrid
        columns={game.type === GameType.Praia ? columnsWithGreens : columns}
        rows={rows}
        loading={loading}
        error={error}
        pageCount={pageCount}
      />
    </TabTableContainer>
  );
};

export default PlayerSessionsDetails;
